export default __webpack_public_path__ + "static/top_recruit_img-706d7605b6f3bf7bafda867fbaf78fc8.jpg";